export default __webpack_public_path__ + "static/media/coin-info.ecfc59cf.png";